
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alphapharm",
      function () {
        return require("private-next-pages/alphapharm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alphapharm"])
      });
    }
  